import { IIdentification } from '@/shared/models/api/identification-model';
import { IdentificationMapper } from '@/shared/mappings/identification-mapper';

class IdentificationService {
    private identificationMapper = new IdentificationMapper();

    constructor() {}
    
    public getStudentIdentifications = (language: string, HttpService: any): Promise<any> => {
        return this.getIdentifications(this.getStudentIdentificationsQuery(language), HttpService)
    }

    public getIdentifications = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IIdentification[]) => {
                let mappedResults = result.map((identification: IIdentification) => this.identificationMapper.mapIdentification(identification));
                resolve(mappedResults);
            }).catch((error: any) => {
                reject(error.msg)
            });
        })
    }

    public getStudentIdentificationsQuery = (language: string): string => {
        return `/api/formdata/${language}/studentidentifications`
    }
}

export default new IdentificationService();